export enum AppAuthorities {

  USERS_CREATE = 'USERS_CREATE',
  USERS_DELETE = 'USERS_DELETE',
  USERS_INACTIVATE = 'USERS_INACTIVATE',
  USERS_ACTIVATE = 'USERS_ACTIVATE',
  USERS_EDIT = 'USERS_EDIT',
  USERS_DETAIL_VIEW = 'USERS_DETAIL_VIEW',
  USERS_UNLOCK = 'USERS_UNLOCK',
  USERS_UPLOAD = 'USERS_UPLOAD',
  ROLES_CREATE = 'ROLES_CREATE',
  ROLES_CLONE = 'ROLES_CLONE',
  ROLES_DELETE = 'ROLES_DELETE',
  ROLES_INACTIVATE = 'ROLES_INACTIVATE',
  ROLES_ACTIVATE = 'ROLES_ACTIVATE',
  ROLES_DETAIL_VIEW = 'ROLES_DETAIL_VIEW',
  ROLES_EDIT = 'ROLES_EDIT',
  APPROVAL_GROUPS_CREATE = 'APPROVAL_GROUPS_CREATE',
  APPROVAL_GROUPS_EDIT = 'APPROVAL_GROUPS_EDIT',
  APPROVAL_GROUPS_DELETE = 'APPROVAL_GROUPS_DELETE',
  APPROVAL_GROUPS_INACTIVATE = 'APPROVAL_GROUPS_INACTIVATE',
  APPROVAL_GROUPS_ACTIVATE = 'APPROVAL_GROUPS_ACTIVATE',
  APPROVAL_GROUPS_UPLOAD = 'APPROVAL_GROUPS_UPLOAD',
  COMPANY_PROFILE_EDIT = 'COMPANY_PROFILE_EDIT',
  COMPANY_PROFILE_CHANGE_PACKAGE = 'COMPANY_PROFILE_CHANGE_PACKAGE',
  COMPANY_PROFILE_CONVERT_TO_PORTAL = 'COMPANY_PROFILE_CONVERT_TO_PORTAL',
  ADDITIONAL_FIELDS_CREATE = 'ADDITIONAL_FIELDS_CREATE',
  ADDITIONAL_FIELDS_EDIT = 'ADDITIONAL_FIELDS_EDIT',
  ADDITIONAL_FIELDS_DELETE = 'ADDITIONAL_FIELDS_DELETE',
  ADDITIONAL_FIELDS_INACTIVATE = 'ADDITIONAL_FIELDS_INACTIVATE',
  ADDITIONAL_FIELDS_ACTIVATE = 'ADDITIONAL_FIELDS_ACTIVATE',
  AUTOMATION_CREATE = 'AUTOMATION_CREATE',
  AUTOMATION_EDIT = 'AUTOMATION_EDIT',
  AUTOMATION_DELETE = 'AUTOMATION_DELETE',
  AUTOMATION_INACTIVATE = 'AUTOMATION_INACTIVATE',
  AUTOMATION_ACTIVATE = 'AUTOMATION_ACTIVATE',
  AUTOMATION_DETAIL_VIEW = 'AUTOMATION_DETAIL_VIEW',
  ITEMS_CREATE = 'ITEMS_CREATE',
  ITEMS_UPLOAD = 'ITEMS_UPLOAD',
  ITEMS_EDIT = 'ITEMS_EDIT',
  ITEMS_DELETE = 'ITEMS_DELETE',
  ITEMS_INACTIVATE = 'ITEMS_INACTIVATE',
  ITEMS_ACTIVATE = 'ITEMS_ACTIVATE',
  ITEMS_DETAIL_VIEW = 'ITEMS_DETAIL_VIEW',
  ACCOUNTS_CREATE = 'ACCOUNTS_CREATE',
  ACCOUNTS_UPLOAD = 'ACCOUNTS_UPLOAD',
  ACCOUNTS_EDIT = 'ACCOUNTS_EDIT',
  ACCOUNTS_DELETE = 'ACCOUNTS_DELETE',
  ACCOUNTS_INACTIVATE = 'ACCOUNTS_INACTIVATE',
  ACCOUNTS_ACTIVATE = 'ACCOUNTS_ACTIVATE',
  ACCOUNTS_DETAIL_VIEW = 'ACCOUNTS_DETAIL_VIEW',
  VENDORS_CREATE = 'VENDORS_CREATE',
  VENDORS_UPLOAD = 'VENDORS_UPLOAD',
  VENDORS_CSV_EXPORT = 'VENDORS_CSV_EXPORT',
  VENDORS_EDIT = 'VENDORS_EDIT',
  SEND_ACH_INFORMATION_REQUEST = 'SEND_ACH_INFORMATION_REQUEST',
  VENDORS_DETAIL_VIEW = 'VENDORS_DETAIL_VIEW',
  VENDOR_COMMUNITY_VENDORS_DETAIL_VIEW = 'VENDOR_COMMUNITY_VENDORS_DETAIL_VIEW',
  VENDORS_DELETE = 'VENDORS_DELETE',
  VENDOR_INACTIVATE = 'VENDOR_INACTIVATE',
  VENDOR_ACTIVATE = 'VENDOR_ACTIVATE',
  REQUEST_ACH_INFO = 'REQUEST_ACH_INFO',
  VENDOR_DETAIL_VIEW = 'VENDOR_DETAIL_VIEW',
  VENDOR_SHOW_BILLS = 'VENDOR_SHOW_BILLS',
  VENDOR_SHOW_BILL_PAYMENTS = 'VENDOR_SHOW_BILL_PAYMENTS',
  VENDOR_SHOW_PURCHASE_ORDERS = 'VENDOR_SHOW_PURCHASE_ORDERS',
  VENDOR_SHOW_PO_RECEIPTS = 'VENDOR_SHOW_PO_RECEIPTS',
  VENDORS_ADD_TO_LOCAL_VENDOR_LIST = 'VENDORS_ADD_TO_LOCAL_VENDOR_LIST',
  VENDORS_MANAGE_VENDOR_REQUEST = 'VENDORS_MANAGE_VENDOR_REQUEST',
  VENDORS_REJECT_VENDOR_REQUEST = 'VENDORS_REJECT_VENDOR_REQUEST',
  VENDORS_DELETE_VENDOR_REQUEST = 'VENDORS_DELETE_VENDOR_REQUEST',
  VENDORS_APPROVE_VENDOR_REQUEST = 'VENDORS_APPROVE_VENDOR_REQUEST',
  VENDORS_RESEND_VENDOR_INVITATION = 'VENDORS_RESEND_VENDOR_INVITATION',
  VENDORS_DELETE_VENDOR_INVITATION = 'VENDORS_DELETE_VENDOR_INVITATION',
  VENDORS_SEND_VENDOR_INVITATION = 'VENDORS_SEND_VENDOR_INVITATION',
  VENDOR_GROUP_CREATE = 'VENDOR_GROUP_CREATE',
  VENDOR_GROUP_EDIT = 'VENDOR_GROUP_EDIT',
  VENDOR_GROUP_DELETE = 'VENDOR_GROUP_DELETE',
  VENDOR_GROUP_INACTIVATE = 'VENDOR_GROUP_INACTIVATE',
  VENDOR_GROUP_ACTIVATE = 'VENDOR_GROUP_ACTIVATE',
  BILL_CREATE = 'BILL_CREATE',
  RECURRING_BILLS_CREATE_BILL = 'RECURRING_BILLS_CREATE_BILL',
  BILL_PROCESS = 'BILL_PROCESS',
  BILL_EDIT = 'BILL_EDIT',
  BILL_APPROVE = 'BILL_APPROVE',
  BILL_REJECT = 'BILL_REJECT',
  BILL_QUICK_APPROVE = 'BILL_QUICK_APPROVE',
  BILL_SKIP_APPROVAL = 'BILL_SKIP_APPROVAL',
  BILL_DETAIL_VIEW = 'BILL_DETAIL_VIEW',
  BILL_VIEW_AUDIT_TRAIL = 'BILL_VIEW_AUDIT_TRAIL',
  BILL_DOWNLOAD_BILL = 'BILL_DOWNLOAD_BILL',
  BILL_APPLY_PAYMENT = 'BILL_APPLY_PAYMENT',
  BILL_VIEW_PAYMENTS = 'BILL_VIEW_PAYMENTS',
  BILL_DELETE = 'BILL_DELETE',
  BILL_CSV_EXPORT = 'BILL_CSV_EXPORT',
  BILL_CHANGE_ASSIGNEE = 'BILL_CHANGE_ASSIGNEE',
  BILL_UNDO_ACTION = 'BILL_UNDO_ACTION',
  BILL_SAVE_AS_APPROVED = 'BILL_SAVE_AS_APPROVED',
  BILL_PAYMENT_VIEW_BILLS = 'BILL_PAYMENT_VIEW_BILLS',
  BILL_ACTIVATE = 'BILL_ACTIVATE',
  BILL_INACTIVATE = 'BILL_INACTIVATE',

  PAYMENT_CREATE = 'PAYMENT_CREATE',
  PAYMENT_UPLOAD = 'PAYMENT_UPLOAD',
  PAYMENT_CHANGE_DOCUMENT = 'PAYMENT_CHANGE_DOCUMENT',
  PAYMENT_MARK_AS_MAILED = 'PAYMENT_MARK_AS_MAILED',
  PAYMENT_REVOKE_PAYMENT = 'PAYMENT_REVOKE_PAYMENT',
  PAYMENT_CHECK_STOP_PAYMENT = 'PAYMENT_CHECK_STOP_PAYMENT',
  PAYMENT_HOLD_PAYMENT = "HOLD_PAYMENT",
  PAYMENT_RELEASE_PAYMENT = "RELEASE_PAYMENT",
  PAYMENT_CHECK_RETURN = 'PAYMENT_CHECK_RETURN',
  PAYMENT_DETAIL_VIEW = 'PAYMENT_DETAIL_VIEW',
  PAYMENT_EDIT_INTEGRATED_ATTENDED = 'EDIT_PAYMENT_INTEGRATED_ATTENDED',
  PAYMENT_CSV_EXPORT = 'PAYMENT_CSV_EXPORT',
  PAYMENT_DOWNLOAD_RECEIPT = 'PAYMENT_DOWNLOAD_RECEIPT',
  PAYMENT_APPROVE = 'PAYMENT_APPROVE',
  PAYMENT_QUICK_APPROVE = 'PAYMENT_QUICK_APPROVE',
  PAYMENT_REJECT = 'PAYMENT_REJECT',
  PAYMENT_OVERRIDE_APPROVAL = 'PAYMENT_OVERRIDE_APPROVAL',
  PAYMENT_VIEW_AUDIT_TRIAL = 'PAYMENT_VIEW_AUDIT_TRIAL',
  PAYMENT_PROCESS_PAYMENT_REQUEST_UPLOAD = 'PAYMENT_PROCESS_PAYMENT_REQUEST_UPLOAD',
  PAYMENT_ACKNOWLEDGEMENT = 'PAYMENT_ACKNOWLEDGEMENT',
  AUTOMATED_PAYMENT_PROCESSING = 'AUTOMATED_PAYMENT_PROCESSING',

  PAYMENT_REQUEST_AUDIT_TRAIL = 'VIEW_UNATTENDED_PAYMENT_AUDIT_TRAIL',
  PAYMENT_REQUEST_HOLD = 'HOLD_UNATTENDED_PAYMENTS',
  PAYMENT_DELETE_INTEGRATED_ATTENDED = 'DELETE_INTEGRATED_PAYMENT_REQUEST',
  PAYMENT_REQUEST_RELEASE = 'RELEASE_UNATTENDED_PAYMENTS',
  PAYMENT_REQUEST_CANCEL = 'CANCEL_UNATTENDED_PAYMENTS',

  PURCHASE_ORDER_SAVE_AS_APPROVED = 'PURCHASE_ORDER_SAVE_AS_APPROVED',
  PURCHASE_ORDER_CREATE = 'PURCHASE_ORDER_CREATE',
  PURCHASE_ORDER_EDIT = 'PURCHASE_ORDER_EDIT',
  PURCHASE_ORDER_DETAIL_VIEW = 'PURCHASE_ORDER_DETAIL_VIEW',
  PURCHASE_ORDER_DELETE = 'PURCHASE_ORDER_DELETE',
  PURCHASE_ORDER_APPROVE = 'PURCHASE_ORDER_APPROVE',
  PURCHASE_ORDER_REJECT = 'PURCHASE_ORDER_REJECT',
  PURCHASE_ORDER_VIEW_AUDIT_TRAIL = 'PURCHASE_ORDER_VIEW_AUDIT_TRAIL',
  PO_GENERATE_PO_RECEIPT = 'PO_GENERATE_PO_RECEIPT',
  PURCHASE_ORDER_CSV_EXPORT = 'PURCHASE_ORDER_CSV_EXPORT',
  PURCHASE_ORDER_DOWNLOAD_REPORT = 'PURCHASE_ORDER_DOWNLOAD_REPORT',
  PURCHASE_ORDER_SEND_ATTACHMENT = 'PURCHASE_ORDER_SEND_ATTACHMENT',
  PURCHASE_ORDER_QUICK_APPROVE = 'PURCHASE_ORDER_QUICK_APPROVE',
  PURCHASE_ORDER_CHANGE_ASSIGNEE = 'PURCHASE_ORDER_CHANGE_ASSIGNEE',
  PURCHASE_ORDER_UNDO_ACTION = 'PURCHASE_ORDER_UNDO_ACTION',
  PURCHASE_ORDER_BILL_CREATE = 'PURCHASE_ORDER_CREATE_BILL',
  PURCHASE_ORDER_CREATE_DIGITAL_CARD = 'PURCHASE_ORDER_CREATE_DIGITAL_CARD',
  PO_NUMBER_CONFIGURATION_CREATE = 'PO_NUMBER_CONFIGURATION_CREATE',
  PO_NUMBER_CONFIGURATION_SEARCH = 'PO_NUMBER_CONFIGURATION_SEARCH',
  PO_NUMBER_CONFIGURATION_EDIT = 'PO_NUMBER_CONFIGURATION_EDIT',
  PO_NUMBER_CONFIGURATION_DELETE = 'PO_NUMBER_CONFIGURATION_DELETE',
  PO_CLOSE = 'CLOSE_PURCHASE_ORDER',
  PO_RE_OPEN = 'RE_OPEN_PURCHASE_ORDER',
  PO_PRICE_VARIANCE_CONFIGURATION_CREATE = 'PO_PRICE_VARIANCE_CONFIGURATION_CREATE',
  PO_PRICE_VARIANCE_CONFIGURATION_SEARCH = 'PO_PRICE_VARIANCE_CONFIGURATION_SEARCH',
  PO_PRICE_VARIANCE_CONFIGURATION_EDIT = 'PO_PRICE_VARIANCE_CONFIGURATION_EDIT',
  PO_PRICE_VARIANCE_CONFIGURATION_DELETE = 'PO_PRICE_VARIANCE_CONFIGURATION_DELETE',

  /*
  Setting configurations tab privileges
   */

  CONFIGURE_PO_VARIANCE_ALLOWANCE = 'CONFIGURE_PO_VARIANCE_ALLOWANCE',
  MANAGE_ADDITIONAL_FIELDS = 'MANAGE_ADDITIONAL_FIELDS',
  MANAGE_SHOW_HIDE_FIELDS = 'MANAGE_SHOW_HIDE_FIELDS',
  PO_NO_CONFIGURATION = 'PO_NO_CONFIGURATION',
  FEATURE_CONFIGURATION = 'FEATURE_CONFIGURATION',
  CONFIGURE_MILEAGE_RATE = 'CONFIGURE_MILEAGE_RATE',

  PAYMENT_DOWNLOAD_ATTACHMENT = 'PAYMENT_DOWNLOAD_ATTACHMENT',
  PAYMENT_PAY_NOW = 'PAYMENT_PAY_NOW',
  PAYMENT_SUBMIT = 'PAYMENT_SUBMIT',
  SCHEDULE_PAYMENT = 'PAYMENT_SCHEDULE_PAYMENT',


  PO_RECEIPT_CREATE = 'PO_RECEIPT_CREATE',
  PO_RECEIPT_EDIT = 'PO_RECEIPT_EDIT',
  PO_RECEIPT_DETAIL_VIEW = 'PO_RECEIPT_DETAIL_VIEW',
  PO_RECEIPT_DELETE = 'PO_RECEIPT_DELETE',
  PO_RECEIPT_ATTACH_TO_A_BILL = 'PO_RECEIPT_ATTACH_TO_A_BILL',
  PO_RECEIPT_CLOSE_PO_RECEIPT = 'PO_RECEIPT_CLOSE_PO_RECEIPT',
  PO_RECEIPT_CSV_EXPORT = 'PO_RECEIPT_CSV_EXPORT',
  PO_RECEIPT_DOWNLOAD_REPORT = 'PO_RECEIPT_DOWNLOAD_REPORT',
  PO_RECEIPT_RE_OPEN_PO_RECEIPT = 'PO_RECEIPT_RE_OPEN_PO_RECEIPT',
  PO_RECEIPT_CREATE_BILL = 'PO_RECEIPT_GENERATE_AN_INVOICE',
  EXPENSE_SAVE_AS_APPROVED = 'EXPENSE_SAVE_AS_APPROVED',
  EXPENSES_CREATE = 'EXPENSES_CREATE',
  EXPENSES_EDIT = 'EXPENSES_EDIT',
  EXPENSES_DRAFT_DISCARD = 'EXPENSES_DRAFT_DISCARD',
  EXPENSES_DRAFT_CREATE = 'EXPENSES_DRAFT_CREATE',
  EXPENSES_UNDO = 'EXPENSES_UNDO',
  EXPENSES_DELETE = 'EXPENSES_DELETE',
  EXPENSES_APPROVE = 'EXPENSES_APPROVE',
  EXPENSES_REJECT = 'EXPENSES_REJECT',

  EXPENSES_VIEW_AUDIT_TRAIL = 'EXPENSES_VIEW_AUDIT_TRAIL',
  EXPENSES_DOWNLOAD_REPORT = 'EXPENSES_DOWNLOAD_REPORT',
  EXPENSES_VIEW_REPORT = 'EXPENSES_VIEW_REPORT',
  EXPENSES_CSV_EXPORT = 'EXPENSES_CSV_EXPORT',
  EXPENSES_QUICK_APPROVE = 'EXPENSES_QUICK_APPROVE',
  EXPENSES_CHANGE_ASSIGNEE = 'EXPENSES_CHANGE_ASSIGNEE',
  EXPENSES_UNDO_ACTION = 'EXPENSES_UNDO',
  PROJECT_CODES_CREATE = 'PROJECT_CODES_CREATE',
  PROJECT_CODES_EDIT = 'PROJECT_CODES_EDIT',
  PROJECT_CODES_DELETE = 'PROJECT_CODES_DELETE',
  PROJECT_CODES_INACTIVATE = 'PROJECT_CODES_INACTIVATE',
  PROJECT_CODES_ACTIVATE = 'PROJECT_CODES_ACTIVATE',
  PROJECT_CODES_UPLOAD = 'PROJECT_CODES_UPLOAD',
  PROJECT_CODES_CSV_EXPORT = 'PROJECT_CODES_CSV_EXPORT',

  BILL_OVERRIDE_APPROVAL = 'BILL_OVERRIDE_APPROVAL',
  PURCHASE_ORDER_OVERRIDE_APPROVAL = 'PURCHASE_ORDER_OVERRIDE_APPROVAL',
  EXPENSES_OVERRIDE_APPROVAL = 'EXPENSES_OVERRIDE_APPROVAL',

  DASHBOARD_SHOW_DISCOUNT_APPLICABLE_TABLE = 'DASHBOARD_SHOW_DISCOUNT_APPLICABLE_BILL_TABLE',
  DASHBOARD_SHOW_MONTHLY_BILLS_AND_PAYMENT_SUMMARY_CHART = 'DASHBOARD_SHOW_MONTHLY_BILLS_AND_PAYMENT_SUMMARY_CHART',
  DASHBOARD_SHOW_PENDING_AND_REJECTED_PO_CARD = 'DASHBOARD_SHOW_PENDING_AND_REJECTED_PO_CARD',
  DASHBOARD_SHOW_VENDOR_REQUEST_CARD = 'DASHBOARD_SHOW_VENDOR_REQUEST_CARD',
  DASHBOARD_SHOW_MONTHLY_TRANSACTION_SUMMARY_CHART = 'DASHBOARD_SHOW_MONTHLY_TRANSACTION_SUMMARY_CHART',
  DASHBOARD_SHOW_PENDING_AND_REJECTED_EXPENSE_CARD = 'DASHBOARD_SHOW_PENDING_AND_REJECTED_EXPENSE_CARD',
  DASHBOARD_SHOW_PENDING_AND_REJECTED_BILLS_CARD = 'DASHBOARD_SHOW_PENDING_AND_REJECTED_BILLS_CARD',
  SHOW_BILLS_AWAITING_YOUR_APPROVAL_TABLE = 'SHOW_BILLS_AWAITING_YOUR_APPROVAL_TABLE',
  SHOW_PO_AWAITING_YOUR_APPROVAL_TABLE = 'SHOW_PO_AWAITING_YOUR_APPROVAL_TABLE',
  SHOW_EXPENSES_AWAITING_YOUR_APPROVAL_TABLE = 'SHOW_EXPENSES_AWAITING_YOUR_APPROVAL_TABLE',

  EXPENSES_SKIP_APPROVAL = 'EXPENSES_SKIP_APPROVAL',
  EXPENSES_DETAIL_VIEW = 'EXPENSES_DETAIL_VIEW',

  PROJECT_CODES_DETAIL_VIEW = 'PROJECT_CODES_DETAIL_VIEW',

  PURCHASE_ORDER_SKIP_APPROVAL = 'PURCHASE_ORDER_SKIP_APPROVAL',
  PURCHASE_ORDER_SEND_VENDOR_APPROVAL = 'PURCHASE_ORDER_SEND_VENDOR_APPROVAL',

  DASHBOARD_SHOW_INVOICE_STATUS_TABLE = 'DASHBOARD_SHOW_INVOICE_STATUS_TABLE',
  DASHBOARD_SHOW_RECEIVED_PAYMENTS_TABLE = 'DASHBOARD_SHOW_RECEIVED_PAYMENTS_TABLE',
  DASHBOARD_SHOW_PO_STATUS_TABLE = 'DASHBOARD_SHOW_PO_STATUS_TABLE',

  DASHBOARD_SHOW_SUB_ACCOUNTS_BILL_SUMMARY = 'DASHBOARD_SHOW_SUB_ACCOUNTS_BILL_SUMMARY',
  DASHBOARD_SHOW_SUB_ACCOUNTS_BILL_PAYMENT_SUMMARY = 'DASHBOARD_SHOW_SUB_ACCOUNTS_BILL_PAYMENT_SUMMARY',
  DASHBOARD_SHOW_SUB_ACCOUNTS_PURCHASE_ORDERS_SUMMARY = 'DASHBOARD_SHOW_SUB_ACCOUNTS_PURCHASE_ORDERS_SUMMARY',
  DASHBOARD_SHOW_SUB_ACCOUNTS_EXPENSE_REPORTS_SUMMARY = 'DASHBOARD_SHOW_SUB_ACCOUNTS_EXPENSE_REPORTS_SUMMARY',

  CUSTOMERS_SEND_REQUEST = 'CUSTOMERS_SEND_REQUEST',
  CUSTOMERS_RESEND_REQUEST = 'CUSTOMERS_RESEND_REQUEST',
  CUSTOMERS_DELETE_REQUEST = 'CUSTOMERS_DELETE_REQUEST',
  PAYMENT_ADD_NOTE = 'PAYMENT_ADD_NOTE',
  INVOICE_ADD_NOTE = 'INVOICE_ADD_NOTE',

  INVOICE_CREATE = 'INVOICE_CREATE',
  PO_INVOICE_CREATE = 'PO_INVOICE_CREATE',
  PAYMENT_SEARCH = 'PAYMENT_SEARCH',
  INVOICE_EDIT = 'INVOICE_EDIT',
  INVOICE_SEARCH = 'INVOICE_SEARCH',
  INVOICE_DETAIL_VIEW = 'INVOICE_DETAIL_VIEW',
  INVOICE_DOWNLOAD_INVOICE = 'INVOICE_DOWNLOAD_INVOICE',
  INVOICE_DELETE = 'INVOICE_DELETE',
  INVIOCE_VIEW_AUDIT_TRAIL = 'INVIOCE_VIEW_AUDIT_TRAIL',
  INVOICE_CSV_EXPORT = 'INVOICE_CSV_EXPORT',
  PO_REJECT = 'PO_REJECT',
  PO_DETAIL_VIEW = 'PO_DETAIL_VIEW',
  PO_GENERATE_AN_INVOICE = 'PO_GENERATE_AN_INVOICE',
  PO_DOWNLOAD_RECEIPT = 'PO_DOWNLOAD_RECEIPT',
  PO_OVERRIDE_APPROVAL = 'PO_OVERRIDE_APPROVAL',
  PO_APPROVE = 'PO_APPROVE',
  PO_UNDER_DISCUSSION = 'PO_UNDER_DISCUSSION',

  SUB_ACCOUNTS_CREATE = 'SUB_ACCOUNTS_CREATE',
  SUB_ACCOUNTS_ACTIVATE = 'SUB_ACCOUNTS_ACTIVATE',
  SUB_ACCOUNTS_INACTIVATE = 'SUB_ACCOUNTS_INACTIVATE',
  SUB_ACCOUNTS_DELETE = 'SUB_ACCOUNTS_DELETE',
  SUB_ACCOUNTS_EDIT = 'SUB_ACCOUNTS_EDIT',

  MANDATORY_FIELD_CONFIGURATION = 'MANDATORY_FIELD_CONFIGURATION',

  PAYMENT_TYPES_ACTIVATE = 'PAYMENT_TYPES_ACTIVATE',
  PAYMENT_TYPES_INACTIVATE = 'PAYMENT_TYPES_INACTIVATE',
  PAYMENT_TYPES_EDIT = 'PAYMENT_TYPES_EDIT',

  PAYMENT_PROVIDER_CREATE = 'PAYMENT_PROVIDER_CREATE',
  PAYMENT_PROVIDER_SEARCH = 'PAYMENT_PROVIDER_SEARCH',
  PAYMENT_PROVIDER_ACTIVATE = 'PAYMENT_PROVIDER_ACTIVATE',
  PAYMENT_PROVIDER_INACTIVATE = 'PAYMENT_PROVIDER_INACTIVATE',
  PAYMENT_PROVIDER_EDIT = 'PAYMENT_PROVIDER_EDIT',

  PAYMENT_CONFIGURATION = 'PAYMENT_CONFIGURATION',
  CONFIGURE_PAYMENT_ACTION = 'CONFIGURE_PAYMENT_ACTION',
  SEND_CONFIGURATION_REQUEST = 'SEND_CONFIGURATION_REQUEST',

  RECURRING_BILLS_CREATE = 'RECURRING_BILLS_CREATE',
  RECURRING_BILLS_DETAIL_VIEW = 'RECURRING_BILLS_DETAIL_VIEW',
  RECURRING_BILLS_ACTIVATE = 'RECURRING_BILLS_ACTIVATE',
  RECURRING_BILLS_INACTIVATE = 'RECURRING_BILLS_INACTIVATE',
  RECURRING_BILLS_EDIT = 'RECURRING_BILLS_EDIT',
  RECURRING_BILLS_DELETE = 'RECURRING_BILLS_DELETE',

  RECURRING_INVOICES_CREATE = 'RECURRING_INVOICES_CREATE',
  RECURRING_INVOICES_DETAIL_VIEW = 'RECURRING_INVOICES_DETAIL_VIEW',
  RECURRING_INVOICES_ACTIVATE = 'RECURRING_INVOICES_ACTIVATE',
  RECURRING_INVOICES_INACTIVATE = 'RECURRING_INVOICES_INACTIVATE',
  RECURRING_INVOICES_EDIT = 'RECURRING_INVOICES_EDIT',
  RECURRING_INVOICES_DELETE = 'RECURRING_INVOICES_DELETE',

  BILL_TEMPLATES_CREATE = 'BILL_TEMPLATES_CREATE',
  BILL_TEMPLATES_EDIT = 'BILL_TEMPLATES_EDIT',
  BILL_TEMPLATES_ACTIVATE = 'BILL_TEMPLATES_ACTIVATE',
  BILL_TEMPLATES_INACTIVATE = 'BILL_TEMPLATES_INACTIVATE',
  BILL_TEMPLATES_DELETE = 'BILL_TEMPLATES_DELETE',
  BILL_TEMPLATES_DETAIL_VIEW = 'BILL_TEMPLATES_DETAIL_VIEW',
  BILL_TEMPLATES_DOWNLOAD = 'BILL_TEMPLATES_DOWNLOAD',

  DEPARTMENT_CREATE = 'DEPARTMENT_CREATE',
  DEPARTMENT_DELETE = 'DEPARTMENT_DELETE',
  DEPARTMENT_EDIT = 'DEPARTMENT_EDIT',
  DEPARTMENT_INACTIVE = 'DEPARTMENT_INACTIVE',
  DEPARTMENT_ACTIVE = 'DEPARTMENT_ACTIVE',

  // inbox auth codes

  INBOX_DELETE = 'INBOX_DELETE',
  INBOX_ATTACH_TO = 'INBOX_ATTACH_TO',
  INBOX_REVIEW = 'INBOX_REVIEW',
  INBOX_MOVE_TO_TO_PROCESS = 'INBOX_MOVE_TO_TO_PROCESS',
  INBOX_RECOVER = 'INBOX_RECOVER',
  INBOX_SEGREGATE = 'INBOX_SEGREGATE',
  INBOX_EMAIL_EDIT = 'INBOX_EMAIL_EDIT',
  INBOX_SEARCH = 'INBOX_SEARCH',

  // show / hide fields

  SHOW_HIDE_FIELD = 'SHOW_HIDE_FIELD',

  // manage feature
  ENABLE_FEATURES = 'ENABLE_FEATURES',

  //Credit Note ------------------------>

  CREDIT_NOTE_CREATE = 'CREDIT_NOTE_CREATE',
  CREDIT_NOTE_EXPORT = 'CREDIT_NOTE_CSV_EXPORT',
  PO_CREATE_CREDIT_NOTE = 'CREATE_CREDIT_NOTE',
  CREDIT_NOTE_EDIT = 'CREDIT_NOTE_EDIT',
  CREDIT_NOTE_SEARCH = 'CREDIT_NOTE_SEARCH',
  CREDIT_NOTE_DELETE = 'CREDIT_NOTE_DELETE',
  CREDIT_NOTE_DETAIL_VIEW = 'CREDIT_NOTE_DETAIL_VIEW',
  CREDIT_NOTE_APPLY_TO_BILL = 'CREDIT_NOTE_APPLY_TO_BILL',
  BILL_APPLY_CREDIT_NOTE = 'BILL_APPLY_CREDIT_NOTE',
  BILL_OFFLINE_PAYMENT_PROCESSING = 'BILL_OFFLINE_PAYMENT_PROCESSING',
  REMOVE_NEGATIVE_BILL = 'REMOVE_NEGATIVE_BILL',
  APPLY_NEGATIVE_BILL = 'APPLY_NEGATIVE_BILL',
  CREDIT_NOTE_VIEW_ATTACHED_BILL = 'CREDIT_NOTE_VIEW_ATTACHED_BILL',
  VIEW_ATTACHED_CREDIT_NOTES = 'VIEW_ATTACHED_CREDIT_NOTES',
  CREDIT_NOTE_SAVE_AS_DRAFT = 'CREDIT_NOTE_SAVE_AS_DRAFT',
  CREDIT_NOTE_SEND_TO_CUSTOMER = 'CREDIT_NOTE_SEND_TO_CUSTOMER',
  VENDOR_CREDIT_NOTE_SEARCH = 'VENDOR_CREDIT_NOTE_SEARCH',
  VENDOR_CREDIT_NOTE_DETAIL_VIEW = 'VENDOR_CREDIT_NOTE_DETAIL_VIEW',
  VENDOR_CREDIT_NOTE_DELETE = 'VENDOR_CREDIT_NOTE_DELETE',
  VENDOR_CREDIT_NOTE_VIEW_ATTACHED_BILLS = 'VENDOR_CREDIT_NOTE_VIEW_ATTACHED_BILLS',
  VENDOR_CREDIT_NOTE_CANCEL = 'VENDOR_CREDIT_NOTE_CANCEL',
  VENDOR_CREDIT_NOTE_EDIT = 'VENDOR_CREDIT_NOTE_EDIT',

  // Credit Card
  CREDIT_CARD_CREATE = 'CREDIT_CARD_CREATE',
  CREDIT_CARD_EDIT = 'CREDIT_CARD_EDIT',
  CREDIT_CARD_DELETE = 'CREDIT_CARD_DELETE',
  CREDIT_CARD_ACTIVATE = 'CREDIT_CARD_ACTIVE',
  CREDIT_CARD_INACTIVATE = 'CREDIT_CARD_INACTIVE',
  CREDIT_CARD_UPLOAD_TRANSACTION = 'CREDIT_CARD_UPLOAD_TRANSACTIONS_UPLOAD',
  CREDIT_CARD_UPLOAD_EDIT = 'CREDIT_CARD_UPLOAD_TRANSACTIONS_EDIT',
  CREDIT_CARD_PROCESS_AUDIT_TRAIL = 'CREDIT_CARD_PROCESS_TRANSACTIONS_VIEW_AUDIT_TRIAL',
  CREDIT_CARD_DELETE_STATEMENT = 'CREDIT_CARD_DELETE_STATEMENT',
  CREDIT_CARD_DELETE_TRANSACTION = 'CREDIT_CARD_DELETE_TRANSACTION',
  CREDIT_CARD_PROCESS_SUBMIT = 'CREDIT_CARD_PROCESS_TRANSACTIONS_SUBMIT',
  CREDIT_CARD_PROCESS_SAVE_AS_APPROVED = 'CREDIT_CARD_PROCESS_TRANSACTIONS_SAVE_AS_APPROVED',
  CREDIT_CARD_PROCESS_TRANSACTION_CREATE = 'CREDIT_CARD_PROCESS_TRANSACTIONS_CREATE',
  CREDIT_CARD_SUBMIT_AUDIT_TRAIL = 'CREDIT_CARD_SUBMITTED_TRANSACTIONS_VIEW_AUDIT_TRIAL',
  CREDIT_CARD_SUBMIT_APPROVE = 'CREDIT_CARD_SUBMITTED_TRANSACTIONS_APPROVE',
  CREDIT_CARD_SUBMIT_OVERRIDE_APPROVE = 'CREDIT_CARD_SUBMITTED_TRANSACTIONS_OVERRIDE_APPROVAL',
  CREDIT_CARD_SUBMIT_QUICK_APPROVE = 'CREDIT_CARD_SUBMITTED_TRANSACTIONS_QUICK_APPROVE',
  CREDIT_CARD_SUBMIT_REJECT = 'CREDIT_CARD_SUBMITTED_TRANSACTIONS_REJECT',
  CREDIT_CARD_SUBMIT_CHANGE_ASSIGNEE = 'CREDIT_CARD_SUBMITTED_TRANSACTIONS_CHANGE_ASSIGNEE',
  CREDIT_CARD_SUBMIT_SKIP_APPROVAL = 'CREDIT_CARD_SUBMITTED_TRANSACTIONS_SKIP_APPROVAL',
  CREDIT_CARD_APPROVED_AUDIT_TRAIL = 'CREDIT_CARD_APPROVED_TRANSACTIONS_VIEW_AUDIT_TRIAL',
  CREDIT_CARD_APPROVED_GENERATE_BILL = 'CREDIT_CARD_APPROVED_TRANSACTIONS_GENERATE_BILL',
  CREDIT_CARD_RECEIPT_UPLOAD = 'CREDIT_CARD_RECEIPT_UPLOAD',
  CREDIT_CARD_RECEIPT_DELETE = 'CREDIT_CARD_RECEIPT_DELETE',
  CREDIT_CARD_VIEW_RECEIPT = 'CREDIT_CARD_VIEW_RECEIPT',
  CREDIT_CARD_RECEIPT_DOWNLOAD_ATTACHMENT = 'CREDIT_CARD_RECEIPT_DOWNLOAD_ATTACHMENT',
  CREDIT_CARD_RECEIPT_UPLOAD_FOR_USER = 'CREDIT_CARD_RECEIPT_UPLOAD_FOR_USER',
  CREDIT_CARD_SPLIT_TRANSACTION = 'CREDIT_CARD_SPLIT_TRANSACTION',


  // Reminder
  REMINDER_CONFIGURATION = 'REMINDER_CONFIGURATION',

  V_CARD_SEARCH = 'V_CARD_SEARCH',
  V_CARD_EDIT = 'V_CARD_EDIT',
  V_CARD_CANCEL = 'V_CARD_CANCEL',
  V_CARD_ACTIVITY_LOG = 'V_CARD_ACTIVITY_LOG',
  V_CARD_DETAIL_VIEW = 'V_CARD_DETAIL_VIEW',
  V_CARD_ACTIVE = 'V_CARD_ACTIVE',
  V_CARD_INACTIVE = 'V_CARD_INACTIVE',
  V_CARD_TOP_UP = 'V_CARD_TOP_UP',

  D_CARD_ACTIVITY_LOG = 'VENDOR_DIGITAL_CARD_VIEW_AUDIT_TRIAL',
  D_CARD_DETAIL_VIEW = 'VENDOR_DIGITAL_CARD_DETAIL_VIEW',
  V_CARD_CREATE = 'V_CARD_CREATE',


  //CUSTOMER INVOICE

  CREATE_INVOICE = 'CREATE_INVOICE',
  EDIT_INVOICE = 'EDIT_INVOICE',
  VIEW_INVOICE_DETAIL_VIEW = 'VIEW_INVOICE_DETAIL_VIEW',
  DELETE_INVOICE = 'DELETE_INVOICE',
  VIEW_INVOICE_AUDIT_TRAIL = 'VIEW_INVOICE_AUDIT_TRAIL',
  DOWNLOAD_INVOICE_RECEPIT = 'DOWNLOAD_INVOICE_RECEPIT',
  EXPORT_INVOICE_CSV = 'EXPORT_INVOICE_CSV',
  MARK_AS_INVOICE_PAID = 'MARK_AS_INVOICE_PAID',
  MARK_AS_INVOICE_UNPAID = 'MARK_AS_INVOICE_UNPAID',
  IMPORT_INVOICE = 'IMPORT_INVOICE',

  // Funding Account

  FUNDING_ACCOUNT_CREATE = 'FUNDING_ACCOUNT_CREATE',
  FUNDING_ACCOUNT_EDIT = 'FUNDING_ACCOUNT_EDIT',
  FUNDING_ACCOUNT_DELETE = 'FUNDING_ACCOUNT_DELETE',
  FUNDING_ACCOUNT_MARK_AS_DEFAULT = 'FUNDING_ACCOUNT_MARK_AS_DEFAULT',
  FUNDING_ACCOUNT_INACTIVATE = 'FUNDING_ACCOUNT_INACTIVE',
  FUNDING_ACCOUNT_ACTIVATE = 'FUNDING_ACCOUNT_ACTIVE',
  UPDATE_EULA_VERSION = "UPDATE_EULA_VERSION",
  EXPORT_REPORT = "EXPORT_REPORT",
  VIEW_EULA_VERSION_HISTORY = "VIEW_EULA_VERSION_HISTORY",
  VIEW_USER_ACCEPTANCE_RECORDS = "VIEW_USER_ACCEPTANCE_RECORDS",
  TRIAL_CONFIG_EDIT = "TRIAL_CONFIG_EDIT",
}








